import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class InternalToolsAuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private AuthService: AuthService
    ) { }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = localStorage.getItem('user');
        const token = localStorage.getItem('current_user_token');
        if (user && token) {
            const r = localStorage.getItem('roles');
            if (r && (r.includes('alpha') || r.includes('Admin')) && user && token) {
                return true;
            }

            else {
                this.router.navigate(['/login']), { queryParams: { returnUrl: state.url } };
                return false;
            }

        }
        this.router.navigate(['/login']), { queryParams: { returnUrl: state.url } };
        return false;

    }


}
